
/**
* @method Block
* @see /src/common/scripts/mixins/Block.js
*
* @param {String} name
* @param {Object} params
*
* @description
*
* Creat a new block (component/container)
*
*	import Block from 'Mixins/Block';
*
*	export default Block('component-input', {
*		fn: {
			myMethod () {
*
				// Code
*
			}
*		},
*		onLoad (qComponent) {
*
*			this.fn.myMethod();
*
*		},
*		onResize () {
*
*			this.fn.myMethod();
*
*		},
*		onScroll () {
*
*			this.fn.myMethod();
*
*		}
*	});
*/

import q from 'Utils/q';
import throttle from 'Utils/throttle';
import utils from 'Utils/utils';

function init (block) {

	let windowWidth = window.innerWidth;
	let windowHeight = window.innerHeight;

	if (block.onLoad) {

		// https://developer.mozilla.org/en-US/docs/Web/Events/readystatechange
		// https://developer.mozilla.org/en-US/docs/Web/API/Document/readyState
		if (document.readyState === 'loading') {

			document.addEventListener('readystatechange', event => {
				if (event.target.readyState === 'interactive') {
					block.onLoad(q(block.selector));
				}
			});

		} else {

			block.onLoad(q(block.selector));

		}

	}

	if (block.onResize) {

		throttle('resize', () => {

			if (windowWidth !== window.innerWidth || windowHeight !== window.innerHeight) {

				windowWidth = window.innerWidth;
				windowHeight = window.innerHeight;

				block.onResize();

			}

		});

	}

	if (block.onScroll) {

		throttle('scroll', () => {

			block.onScroll();

		});

	}

}

class Block {

	constructor (name, params) {

		if (!utils.isNotEmptyString(name)) {

			return;

		}

		this.name 		= name;
		this.selector 	= '.'+name;
		this.fn 		= utils.checkIf('isNotEmptyObject', params.fn, null);
		this.onLoad 	= utils.checkIf('isFunction', params.onLoad, null);
		this.onResize 	= utils.checkIf('isFunction', params.onResize, null);
		this.onScroll 	= utils.checkIf('isFunction', params.onScroll, null);

		init(this);

	}

}

export default (name, params) => {

	return new Block(name, params);

};
